import update from 'immutability-helper'

export const showLoader = (state, action) => update(state, { loading: { $set: true } })
export const hideLoader = (state, action) => update(state, { loading: { $set: false } })

export const contactSent = (state, action) => update(state, { success: { $set: true }, error: { $set: false } })
export const contactSendFailed = (state, action) => update(state, { success: { $set: false }, error: { $set: true } })


// WEBPACK FOOTER //
// ./src/store/contacts/reducerActions.js